<mat-button-toggle-group>
  <mat-button-toggle
    [disabled]="disabled$ | async"
    matTooltip="Toggle side panels"
    (click)="toggleExpanded()"
  >
    <fa-icon [icon]="faAngleDoubleRight" [flip]="flip$ | async"></fa-icon>
  </mat-button-toggle>
</mat-button-toggle-group>
